// Reuse the theme's existing Smile hash trigger; retain the community fallback.
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('[data-xp-aff-referral]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (window.Smile || window.SmileUI) {
    event.preventDefault();
    window.location.hash = 'smile-home';
  }
});
